export { GoogleTagManagerEvents, StandardData } from "./GoogleTagManagerEvents";
